// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.esD2WrVvsuaTaChRe7uw {
  display: flex;
  background: #fff;
  min-height: calc(100vh - 52px);
}
.esD2WrVvsuaTaChRe7uw .gMmtBZ30z0d57rnV1PMR {
  flex: 0 0 250px;
  min-height: 100%;
  background: #f7f8f9;
  border-radius: 4px;
  padding: 10px;
}
.esD2WrVvsuaTaChRe7uw .Qzw0q0J_PH37YdTJEjuG {
  flex: auto;
  margin-left: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Setting/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,gBAAA;EACA,8BAAA;AAAF;AAHA;EAMI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAAJ;AAVA;EAcI,UAAA;EACA,iBAAA;AADJ","sourcesContent":["\n.container {\n  display: flex;\n  background: #fff;\n  min-height: calc(100vh - 52px);\n\n  .sider {\n    flex: 0 0 250px;\n    min-height: 100%;\n    background: #f7f8f9;\n    border-radius: 4px;\n    padding: 10px;\n  }\n\n  .content {\n    flex: auto;\n    margin-left: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `esD2WrVvsuaTaChRe7uw`,
	"sider": `gMmtBZ30z0d57rnV1PMR`,
	"content": `Qzw0q0J_PH37YdTJEjuG`
};
export default ___CSS_LOADER_EXPORT___;
